"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    logoButtonSvgFill: {
        fill: function (data) { return data.color; },
    },
};
//# sourceMappingURL=logo.theme.js.map